import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark-900 focus:ring-gold-500 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-gold-500 text-dark-900 hover:bg-gold-400 shadow-lg shadow-gold-900/20',
    secondary: 'bg-dark-400 text-gold-400 hover:bg-dark-300 border border-dark-300',
    outline: 'bg-transparent border-2 border-gold-500 text-gold-500 hover:bg-gold-500 hover:text-dark-900',
    ghost: 'bg-transparent text-dark-100 hover:text-gold-400 hover:bg-dark-800'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-8 py-3.5 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-155" data-mp="tkkfcwdzbevz">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-156" data-mp="12m0lut1oawux" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-157" data-mp="xnqs8mvlk4bf">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-158" data-mp="1ccd7ypp4yy36">{rightIcon}</span>}
    </button>;
}